module.exports = __webpack_public_path__ + "rw-widgets.eot";


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/fonts/rw-widgets.eot
// module id = 750
// module chunks = 0